import script from "./PlayoffMatch.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayoffMatch.vue?vue&type=script&setup=true&lang=js"

import "./PlayoffMatch.vue?vue&type=style&index=0&id=71119e55&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71119e55"]])

export default __exports__